var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashSolidWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 448 538",
    style: {
      enableBackground: "new 0 0 448 538"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.2,30.7L128,45H32C14.3,45,0,59.3,0,77s14.3,32,32,32h384c17.7,0,32-14.3,32-32s-14.3-32-32-32h-96 l-7.2-14.3C307.4,19.8,296.3,13,284.2,13H163.8C151.7,13,140.6,19.8,135.2,30.7z M416,141H32l21.2,339c1.6,25.3,22.6,45,47.9,45 h245.8c25.3,0,46.3-19.7,47.9-45L416,141z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashSolidWhite);
export default __webpack_public_path__ + "static/media/trash-solid-white.d63d586ad9d692c8ba53945c229e158c.svg";
export { ForwardRef as ReactComponent };